export default __webpack_public_path__ + "static/media/laptop.8aca9498.png";